import { InputField } from "client/CommonComponents";
import PODetailGrid from "./PODetailGrid"
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveBulkOrderFleetAsset, saveBulkOrderFleetBarcode, setBulkOrderFleetAsset, setBulkOrderFleetBarcode, setBulkOrderFleetHeader } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import userProfileSelectors from '../../../../../redux/UserProfile/selectors'
import { CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";

const CustomInputFilterComponent = (props: any) => {
    const {
        row,
        fleetDetails,
        onChange,
        onBlur,
        error,
        disabled,
        name,
        value
    } = props;
    return (
        <div className="date-filter-wrapper">
            <InputField 
                placeholder={`${name === "assetNumber" ? "Enter Asset Number" : "Enter Barcode Number"}`}
                value={value}
                onChange={(e:any)=>onChange(name, e.target.value, row.rowData, fleetDetails, `${name}Error`)}
                disabled = {disabled}
                onBlur={(e:any)=>onBlur(name, e.target.value, row.rowData)}
                className={error ? 'controlValidation' :''}
             data-attribute="PODetailGrid_container_Default_Input" />
            <p className="asset-validation-msg">{error}</p>
        </div>
    );
}

const PODetailGridContainer = (props:any) => {
    const {
        purchaseDetailsItem,
        purchaseOrderStepperData,
        isDisplayInPopUp,
        id
    } = props;

    const dispatch = useDispatch();
    const purchaseFleetDetails: any = useRef("");
    const [showGrid, setShowGrid] = useState<any>(false);

    const {
        bulkOrderAssetDetail,
        bulkOrderFleetDetails,
        userDetails,
        bulkOrderBarcodeDetail
    }: any = useSelector((state?: any) => ({
        bulkOrderAssetDetail: state.PurchaseBulkOrderReducer.bulkOrderAssetDetail,
        bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
        userDetails: userProfileSelectors.getUserDetails(state),
        bulkOrderBarcodeDetail: state.PurchaseBulkOrderReducer.bulkOrderBarcodeDetail,
    }));

    useEffect(() => {
        if (bulkOrderFleetDetails) {
            if (id == bulkOrderFleetDetails[0]?.orderId) {
                purchaseFleetDetails.current = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : [];
            }
        }
    }, [bulkOrderFleetDetails])

    useEffect(() => {
        setShowGrid(false);
        setTimeout(() => {
            setShowGrid(true);
        })
    }, [JSON.stringify(purchaseOrderStepperData?.orderDetailId)])

    const updateFleetDetails = (details: any, purchaseFleetDetails: any, errorField: string, name: string) => {
        const bulkOrderFleetDetailsTemp: any = purchaseFleetDetails ? JSON.parse(JSON.stringify(purchaseFleetDetails)) : []
        let isUpdated = false;
        bulkOrderFleetDetailsTemp?.forEach((item?: any) => {
            if (item?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
                item?.purchaseDetails?.items?.forEach((childItem: any) => {
                    if (childItem.fleetDetailId == details?.fleetRequestDetailId) {
                        isUpdated = true;
                        childItem[errorField] = details?.validationMessage
                        childItem[name] = details[name];
                    }
                })
            }
        })
        if (isUpdated) {
            dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        }
    }

    useEffect(()=>{
        if(bulkOrderAssetDetail?.assetNumber){
            updateFleetDetails(bulkOrderAssetDetail, purchaseFleetDetails.current, "assetNumberError", "assetNumber")
            dispatch(setBulkOrderFleetAsset({}))
        }    
    },[bulkOrderAssetDetail])

    useEffect(()=>{
        if(bulkOrderBarcodeDetail){
            updateFleetDetails(bulkOrderBarcodeDetail, purchaseFleetDetails?.current, "barcodeNoError", "barcodeNo")
            dispatch(setBulkOrderFleetBarcode(undefined))
        }    
    },[bulkOrderBarcodeDetail])


    const onChangeInput = (name: string, value: any, rowData: any, fleetDetails: any, errorField: string) => {

        if (name === "assetNumber" && value !== "") {
            const regEx = /^\d{0,9}(\.\d{1,4})?$/;
            const valArr = value.split('.')
            const checkNumber = regEx.test(value);
            if (!checkNumber || valArr.length > 1) {
                return;
            }
        }

        let errorMsg = ""
        if(name === "barcodeNo" && value?.length > 50){
            errorMsg = "Barcode Number should not exceed 50 characters."
        } else if(name === "assetNumber" && value?.length <= 0){
            errorMsg = "Asset Number is Required."
        }
        
        updateFleetDetails(
            {
                fleetRequestDetailId: rowData?.fleetDetailId,
                isValid: true,
                validationMessage: errorMsg,
                [name]: value
            },
            fleetDetails,
            errorField,
            name
        )
    };

    const onBlurInput = (name: string, value: any, rowData: any) => {
        const isValid = name === "assetNumber" ? value?.length > 0 : value?.length <= 50;
        if (isValid) {
            let payload: any = {
                "fleetDetailId": rowData?.fleetDetailId,
                "savedBy": userDetails?.emailId,
            }
            if (name === "assetNumber" && value) {
                payload.assetNumber = value
                dispatch(saveBulkOrderFleetAsset(payload))
            } else if (name === "barcodeNo"){
                payload.barcodeNo = value || null
                dispatch(saveBulkOrderFleetBarcode(payload))
            }
        }
    }

    const isItemCancelledOrCompleted = (fleetId: number) => {
        let itemStatus = purchaseOrderStepperData?.taskHeaderDetails?.find((item: any) => item?.fleetDetailId === fleetId)?.itemStatus
        return itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE
    }


    const columns = [
        {
            key: "itemId",
            title: "Item ID",
            width:"150px"
        },
        {
          key: "assetNumber",
          title: "Asset",
            Cell: (row: any) => (
                <CustomInputFilterComponent
                    name="assetNumber"
                    row={row}
                    value={row?.rowData?.assetNumber} 
                    fleetDetails={purchaseFleetDetails.current}
                    onChange={onChangeInput}
                    onBlur={onBlurInput}
                    error={row.rowData.assetNumberError}
                    disabled={purchaseOrderStepperData?.isPOCreated || isDisplayInPopUp || row.rowData.poNumber || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                />),
          width:"200px"
        },
        {
          key: "poNumber",
          title: "PO#",
          width:"150px"
        },
        {
            key: "barcodeNo",
            title: "Barcode",
            Cell: (row: any) => (
                <CustomInputFilterComponent
                    name="barcodeNo"
                    row={row}
                    value={row?.rowData?.barcodeNo}  
                    fleetDetails={purchaseFleetDetails.current}
                    onChange={onChangeInput}
                    onBlur={onBlurInput}
                    error={row.rowData.barcodeNoError}
                    disabled={isItemCancelledOrCompleted(row?.rowData.fleetDetailId) || !isAuthorized(permissions.CreateUpdatePurchaseOrders) || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                />),
            width:"200px"
        },
        {
          key: "poCreationDate",
          title: "PO Date #",
          width:"200px"
        }
    ];

    return(
        <PODetailGrid
            purchaseDetailsItem={purchaseDetailsItem} 
            columns={columns}  
            showGrid = {showGrid} 
        />
    )
}

export default PODetailGridContainer